import React, { MouseEventHandler } from 'react'

import {
	AccordionItem,
	AccordionRoot,
	StyledChevron,
	StyledContent,
	StyledContentText,
	StyledHeader,
	StyledTrigger,
	StyledLink,
	StyledNumber,
} from './styles'

const AccordionTrigger = React.forwardRef(
	({
		children,
		paddingLeft,
		questionCount,
		isOpen,
		onClick,
		...props
	}: {
		children: React.ReactNode
		paddingLeft?: boolean
		questionCount?: number
		isOpen: boolean
		onClick?: MouseEventHandler<HTMLButtonElement>
	}) => (
		<StyledHeader>
			<StyledTrigger
				{...props}
				paddingLeft={paddingLeft}
				onClick={onClick}
				isOpen={isOpen}
			>
				{children}
				<StyledNumber>
					{questionCount && <p>{questionCount} Questões</p>}
					<StyledChevron aria-hidden isOpen={isOpen} />
				</StyledNumber>
			</StyledTrigger>
		</StyledHeader>
	)
)

const AccordionContent = React.forwardRef(
	({
		children,
		sub,
		questionCount,
		onClick,
		...props
	}: {
		children: React.ReactNode
		questionCount?: number
		sub?: boolean
		onClick?: MouseEventHandler<HTMLButtonElement>
	}) => (
		<StyledContent {...props}>
			<StyledContentText sub={sub} onClick={onClick}>
				{children}
				{questionCount && (
					<StyledNumber>
						<p>{questionCount} Questões</p>
					</StyledNumber>
				)}
			</StyledContentText>
		</StyledContent>
	)
)

export interface ListSubMatters {
	id: number
	name: string
	matterId: number
	questionCount: number
}

export interface ListMatters {
	id: number
	name: string
	disciplineId: number
	submatters: Array<ListSubMatters>
	questionCount: number
}

interface AccordionProps {
	id: number
	index: number
	discipline: string
	matters: Array<ListMatters>
	questionCount: number
}

const AccordionList = ({
	id,
	index,
	discipline,
	matters,
	// eslint-disable-next-line @typescript-eslint/no-unused-vars
	questionCount,
	...props
}: AccordionProps) => {
	const [isOpenDiscipline, setIsOpenDiscipline] = React.useState(false)

	const handleAccordionToggleDiscipline = () => {
		setIsOpenDiscipline(!isOpenDiscipline)
	}

	const [isOpenMatter, setIsOpenMatter] = React.useState<{
		[key: string | number]: boolean
	}>({})

	const handleAccordionToggleMatter = (AccordionId: string | number) => {
		setIsOpenMatter((prevState) => ({
			...prevState,
			[AccordionId]: !prevState[AccordionId],
		}))
	}

	return (
		<AccordionRoot type='multiple' {...props}>
			<AccordionItem value={discipline} border>
				<AccordionTrigger
					key={id}
					onClick={handleAccordionToggleDiscipline}
					isOpen={isOpenDiscipline}
				>
					<StyledLink
						to={`/disciplinas/questoes?discipline=${id}`}
						isOpen={isOpenDiscipline}
					>
						<h6>{`${index}.`}</h6>
						<h6 className='title'>{discipline}</h6>
					</StyledLink>
				</AccordionTrigger>

				{matters.map(({ id: idMatter, name, submatters }, indexMatter) => (
					<AccordionContent key={idMatter}>
						<AccordionItem value={`matter${name}`}>
							<AccordionTrigger
								key={id}
								paddingLeft
								onClick={() => handleAccordionToggleMatter(idMatter)}
								isOpen={isOpenMatter[idMatter]}
							>
								<StyledLink
									to={`/disciplinas/questoes?discipline=${id}&matter=${idMatter}`}
									sub
									isOpen={isOpenMatter[idMatter]}
								>
									<h6>{`${index}.${indexMatter + 1}.`}</h6>
									<h6>{name}</h6>
								</StyledLink>
							</AccordionTrigger>

							{submatters.map(
								({ id: idSubMatter, name: subName }, indexSubMatter) => (
									<AccordionContent key={idSubMatter} sub>
										<StyledLink
											to={`/disciplinas/questoes?discipline=${id}&matter=${idMatter}&subMatter=${idSubMatter}`}
											sub
										>
											<h6>{`${index}.${indexMatter + 1}.${
												indexSubMatter + 1
											}`}</h6>
											<h6>{subName}</h6>
										</StyledLink>
									</AccordionContent>
								)
							)}
						</AccordionItem>
					</AccordionContent>
				))}
			</AccordionItem>
		</AccordionRoot>
	)
}

export default AccordionList
